import { styled } from "@vitality-ds/system";
import BaseBoxStyles from "./styles/BaseBox.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseBox = styled("div", BaseBoxStyles);